import React from 'react';
import { Result } from 'antd';

const Forbidden = () => (
  <Result
    status="403"
    title="403"
    subTitle="No cuentas con permisos suficientes para acceder a este recurso del módulo contable."
  />
);

export default Forbidden;
